import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';

import { MessagePropType, Question } from '@ratehub/base-ui';
import { GenderOptions, GENDER_MESSAGES } from '@ratehub/ins-common';


function QuestionGender({
    name,
    value,
    labelMessage,
}) {
    return (
        <Question
            field={{
                name: name || 'gender',
                value,
                options: GenderOptions,
                type: 'choice',
            }}
            type="radio"
            labelMessage={labelMessage || (
                <FormattedMessage
                    id="InsLifeWizard.QuestionGender"
                    defaultMessage="What is your sex?"
                />
            )}
            tooltipMessage={(
                <FormattedMessage
                    id="InsLifeWizard.QuestionGender.tooltip"
                    defaultMessage="Life insurance companies currently require a male of female distinction when quoting. Please identify your sex at birth, unless you’ve had gender reassignment surgery."
                />
            )}
            quicktipMessage={GENDER_MESSAGES.quicktip}
            shouldDisplayOptionsAsGrid
        />
    );
}

QuestionGender.propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    labelMessage: MessagePropType,
};

export default observer(QuestionGender);
